export default __webpack_public_path__ + "static/media/twoleaf.4e62bc58.svg";